import "./Skeleton.css";

export function SkeletonCard() {
  return (
    <div className="pa-card pa-skel" aria-hidden="true">
      <div className="skeleton skeleton-cover" />
      <div className="skeleton skeleton-line skeleton-line--xs" />
      <div className="skeleton skeleton-line skeleton-line--lg" />
      <div className="skeleton skeleton-line skeleton-line--md" />
      <div className="skeleton skeleton-line skeleton-line--sm" />
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div
      className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 pa-grid"
      role="status"
      aria-label="Chargement des événements"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div className="col" key={i}>
          <SkeletonCard />
        </div>
      ))}
    </div>
  );
}

// Loading shape for the event detail page: cover plus a column of text.
export function SkeletonEvent() {
  return (
    <div className="pa-skel" role="status" aria-label="Chargement de l'événement">
      <div className="skeleton skeleton-line skeleton-line--xs" />
      <div className="skeleton skeleton-title" />
      <div className="skeleton skeleton-line skeleton-line--md" />
      <div className="skeleton skeleton-hero" />
      <div className="skeleton skeleton-line skeleton-line--lg" />
      <div className="skeleton skeleton-line skeleton-line--lg" />
      <div className="skeleton skeleton-line skeleton-line--md" />
    </div>
  );
}

